const s = {
  name: "House2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M28,9H12v10h16V9z M14,17v-6h2v6H14z M22,11v6h-4v-6H22z M24,11h2v6h-2V11z"/>
		<path class="st0" d="M18,36V25h14v11H18z M30,29v-2H20v2H30z M20,31v3h10v-3H20z"/>
		<path class="st0" d="M12,0h6v4h16.8l3.4,19H36v15h4v2H0v-2h4V23H1.8L5.2,4H12V0z M16,2h-2v2h2V2z M6.8,6L4.2,21h31.6L33.2,6H6.8z
			 M16,38h18V23H6v15h2V25h8V38z M14,34v-7h-4v7H14z M10,36v2h4v-2H10z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as House2
};
